const Footer = () => {
  return ( 
    <footer id="footer">
        <p>Copyright &copy; 2022 Rakodashi</p>
    </footer>
   );
}
 
export default Footer;